import { __read, __assign } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useState, useMemo, useEffect, useCallback } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Card, Space, Button } from '@sravni/react-design-system';
import { Heading } from '@sravni/react-design-system/lib/Typography';
import { useIsMobile } from '@sravni/react-utils';
import { yupResolver } from '@hookform/resolvers/yup';
import { useAnalytics } from '../../../../analytics/hooks.js';
import '../../../../analytics/context.js';
import { FORM_FIELDS } from '../../../../constants/form.js';
import '../../../../constants/sources.js';
import { pick } from '../../../../helpers/index.js';
import { formatNumber } from '../../../../helpers/fomatters.js';
import { ConditionsSelector } from '../../../ConditionsSelector/ConditionsSelector.js';
import { SelectInput } from '../../../Form/Select/select.input.js';
import { EVENT_TYPE } from '../../constants.js';
import { useSelectionCalculator } from '../../hooks.js';
import { schema } from '../../schema.js';
import { Feature } from '../Feature/Feature.js';
import { Service } from '../Service/Service.js';
import modules_2904d714 from './Calculator.module.scss.js';
import { useFormOnBlur } from './hooks.js';

var DEFAULT_HEADER = 'Подберем банки, которые готовы выдать вам кредит';
var Calculator = function (_a) {
    var _b = _a.head, head = _b === void 0 ? DEFAULT_HEADER : _b, isLoggedInEsia = _a.isLoggedInEsia;
    var isMobile = useIsMobile();
    var _c = useSelectionCalculator(), baseUrl = _c.baseUrl, formValues = _c.formValues, formParams = _c.formParams, onEvent = _c.onEvent, eventFormValues = _c.eventFormValues;
    var amount = formValues.amount, period = formValues.period, purpose = formValues.purpose, rate = formValues.rate, payment = formValues.payment;
    var amountParams = formParams.amount, periodOptions = formParams.periodOptions, purposeOptions = formParams.purposeOptions;
    var eventLabelPage = useAnalytics().eventLabelPage;
    var _d = __read(useState(amount), 2), sliderAmount = _d[0], setSliderAmount = _d[1];
    var formData = useMemo(function () { return pick(formValues, [FORM_FIELDS.PURPOSE, FORM_FIELDS.AMOUNT, FORM_FIELDS.PERIOD]); }, [formValues]);
    var form = useForm({
        resolver: yupResolver(schema({
            amountMax: amountParams.max,
            amountMin: amountParams.min,
            periods: periodOptions.map(function (item) { return item.value; }),
            purposes: purposeOptions.map(function (item) { return item.value; }),
        })),
        mode: 'onBlur',
        reValidateMode: 'onBlur',
    });
    var control = form.control; form.formState.dirtyFields; var reset = form.reset, handleSubmit = form.handleSubmit, setValue = form.setValue;
    var formOnBlur = useFormOnBlur(form);
    useEffect(function () {
        reset(formData, {
            keepErrors: true,
            keepDirtyValues: true,
        });
    }, [formData, reset]);
    useEffect(function () {
        if (onEvent) {
            onEvent({
                type: EVENT_TYPE.CALCULATOR_MOUNT,
                payload: __assign(__assign({}, eventFormValues), { page: eventLabelPage }),
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleAmountChange = useCallback(function (value) {
        setValue(FORM_FIELDS.AMOUNT, value, { shouldValidate: true });
        formOnBlur({ target: { name: FORM_FIELDS.AMOUNT } });
    }, [setValue, formOnBlur]);
    useEffect(function () {
        handleAmountChange(sliderAmount);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sliderAmount]);
    var getAfterAuthUrl = useCallback(function (from) {
        var currentParams = new URLSearchParams(window.location.search);
        currentParams.set('amount', String(amount));
        currentParams.set('period', period);
        currentParams.set('purpose', purpose);
        currentParams.set('skipLanding', 'true');
        currentParams.set('after_calculator_auth', from);
        return "".concat(baseUrl, "/kredity/onlajn-zayavka-na-kredit/?").concat(currentParams.toString());
    }, [amount, baseUrl, period, purpose]);
    var onConfirm = useCallback(function () {
        if (onEvent) {
            onEvent({
                type: EVENT_TYPE.CALCULATOR_REDIRECT_TO_FORM,
                payload: __assign(__assign({}, eventFormValues), { label: 'Войти Подбор', page: eventLabelPage }),
            });
        }
        window.location.href = getAfterAuthUrl('button');
    }, [getAfterAuthUrl, onEvent, eventFormValues, eventLabelPage]);
    var onClick = useCallback(function () {
        if (onEvent) {
            onEvent({
                type: EVENT_TYPE.CALCULATOR_BUTTON_CLICK,
                payload: {
                    label: 'Продолжить',
                    page: eventLabelPage,
                },
            });
        }
    }, [onEvent, eventLabelPage]);
    return (jsx("form", { onBlur: formOnBlur, onSubmit: handleSubmit(onConfirm), className: modules_2904d714.form, children: jsx(Card, { size: isMobile ? 16 : 24, children: jsxs(Space, { direction: "vertical", size: 16, children: [jsx(Heading, { level: isMobile ? 2 : 4, children: head }), jsxs(Space, { size: 16, wrap: isMobile, children: [jsx(ConditionsSelector, { sliderAmount: sliderAmount, control: control, setSliderAmount: setSliderAmount, formParams: formParams }), jsx(Controller, { name: FORM_FIELDS.PURPOSE, control: control, render: function (_a) {
                                    var field = _a.field;
                                    return (jsx(SelectInput, __assign({}, field, { className: modules_2904d714.purposeSelect, label: "\u0426\u0435\u043B\u044C \u043A\u0440\u0435\u0434\u0438\u0442\u0430", options: formParams.purposeOptions, withCrossIcon: false })));
                                } }), jsx(Button, { block: isMobile, type: "submit", onClick: onClick, variant: "primary", size: 60, children: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C" })] }), jsx(Card, { color: "blue", size: 16, children: jsxs(Space, { justify: "space-between", direction: isMobile ? 'vertical' : 'horizontal', size: 16, children: [jsxs(Space, { inline: true, size: 24, children: [jsx(Feature, { title: "".concat(rate, "%"), subtitle: "\u0421\u0440\u0435\u0434\u043D\u044F\u044F \u0441\u0442\u0430\u0432\u043A\u0430" }), jsx(Feature, { title: "".concat(formatNumber(payment), " \u20BD/\u043C\u0435\u0441"), subtitle: "\u041F\u0440\u043E\u0433\u043D\u043E\u0437\u043D\u044B\u0439 \u043F\u043B\u0430\u0442\u0435\u0436" })] }), !isLoggedInEsia && jsx(Service, { backUrl: getAfterAuthUrl('gosuslugi') })] }) })] }) }) }));
};

export { Calculator };
//# sourceMappingURL=Calculator.js.map
